<template>
	<v-card>
		<!-- <v-card-title class="">
			报表
			<template v-if="form && form.id">
				编辑
				<v-btn icon @click.stop="copy"><v-icon>mdi-content-copy</v-icon></v-btn>
			</template>
			<template v-else>创建</template>
		</v-card-title> -->
		<v-card-text>
			<v-row>
				<v-col cols="12" sm="6">
					<v-row>
						<v-col cols="12">
							<v-text-field
								label="名称*"
								name="name"
								v-model="form.name"
								:error-messages="errors.name"
								required
								clearable
								style="width: 30rem"
								class="d-inline-block mr-2"
							></v-text-field>
							<v-text-field
								label="编码"
								placeholder=""
								v-model="form.code"
								:error-messages="errors.code"
								clearable
								style="width: 10rem"
								class="d-inline-block mr-2"
							></v-text-field>
							<v-text-field
								type="number"
								label="排序值1"
								v-model="form.sort"
								persistent-hint
								style="width: 10rem"
								class="d-inline-block mr-2"
							>
								<!-- <template v-slot:append> -->
								<!-- <v-tooltip right class="d-inline-block"> -->
								<!-- <template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">$info</v-icon>
										</template> -->
								<!-- <span>默认排序值越大越靠后</span> -->
								<!-- </v-tooltip> -->
								<!-- </template> -->
							</v-text-field>
							<v-select
								:items="options['ReportType']"
								v-model="form.type"
								:error-messages="errors.type"
								label="类型"
								auto
								style="width: 10rem"
								class="d-inline-block mr-2"
								required
								item-text="title"
								item-value="value"
								persistent-hint
							></v-select>
							<v-select
								:items="options['ReportStatus']"
								v-model="form.status"
								:error-messages="errors.status"
								label="状态"
								auto
								style="width: 10rem"
								item-text="title"
								item-value="value"
								class="d-inline-block mr-2"
								required
							></v-select>
							<v-textarea
								v-model="form.description"
								label="备注"
								rows="2"
								style="width: 30rem"
								class="d-inline-block mr-2"
								outlined
							></v-textarea>
						</v-col>
						<!-- 导致报错 fixlater-->
						<!-- <v-card width="100%" class="mb-2">
						<v-card-title>标签</v-card-title>
						<v-card-subtitle>用于报表的分类</v-card-subtitle>
						<v-card-text>
							<tag-editor
								:init-tags="form.tags"
								updatable
								deletable
								@changed="onTagsChanged"
							></tag-editor>
						</v-card-text>
					</v-card> -->
						<v-card width="100%" class="mb-2">
							<v-card-title>
								列
								<v-btn icon outlined small color="primary" @click="addColumn">
									<v-icon>$plus</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text>
								<v-table>
									<thead>
										<tr>
											<th>列名</th>
											<th>显示名称</th>
											<th>排序</th>
											<th>链接</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(c, i) in columns" :key="i">
											<td>{{ c.name }}</td>
											<td>{{ c.displayname }}</td>
											<td>{{ c.sort }}</td>
											<td>{{ c.link }}</td>
											<td>
												<v-btn small @click="updateColumn(c)">修改</v-btn>
												<v-btn small text color="error" @click="removeColumn(c)">删除</v-btn>
											</td>
										</tr>
									</tbody>
								</v-table>
								<v-dialog v-model="showColumnForm" max-width="400" :persistent="false">
									<v-card>
										<column-form
											:errors="columnErrors"
											v-model:value="editingColumn"
											v-if="editingColumn"
											:key="editingColumn.id"
										>
											<template #actions="{ object }">
												<v-btn @click="saveColumn(object)">保存</v-btn>
											</template>
										</column-form>
									</v-card>
								</v-dialog>
							</v-card-text>
						</v-card>
						<v-card width="100%" class="mb-2">
							<v-card-title>
								参数
								<v-btn icon outlined small color="primary" @click="addParameter">
									<v-icon>$plus</v-icon>
								</v-btn>
							</v-card-title>
							<v-table>
								<thead>
									<tr>
										<th>参数名</th>
										<th>KEY</th>
										<th>类型</th>
										<th>备注</th>
										<th>默认值</th>
										<th>排序</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(c, i) in parameters" :key="i">
										<td>{{ c.label }}</td>
										<td>{{ c.name }}</td>
										<td>{{ c.type }}</td>
										<td>{{ c.description }}</td>
										<td>{{ c.defaultvalue }}</td>
										<td>{{ c.sort }}</td>
										<td>
											<v-btn small @click="updateParameter(c)">修改</v-btn>
											<v-btn small text color="error" @click="removeParameter(c)">删除</v-btn>
										</td>
									</tr>
								</tbody>
							</v-table>
							<v-dialog v-model="showParameterForm" max-width="400" :persistent="false">
								<v-card>
									<parameter-form
										:errors="parameterErrors"
										:key="editingParameter.id"
										v-model:value="editingParameter"
										v-if="editingParameter"
									>
										<template #actions="{ object }">
											<v-card-text>
												<v-btn @click="saveParameter(object)">保存</v-btn>
											</v-card-text>
										</template>
									</parameter-form>
								</v-card>
							</v-dialog>
						</v-card>
					</v-row>
				</v-col>
				<v-col cols="12" sm="6">
					<Codemirror
						ref="cmEditor"
						v-model="form.sqltext"
						:extensions="extensions"
						style="width: 100%; height: 400px"
					/>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<slot name="actions" v-bind:object="form"></slot>
		</v-card-actions>
	</v-card>
</template>

<script>
import TagEditor from '../common/TagEditor.vue'
import ColumnForm from './ColumnForm.vue'
import ParameterForm from './ParameterForm.vue'
import { sql } from '@codemirror/lang-sql'
import { oneDark } from '@codemirror/theme-one-dark'
import { EditorView } from '@codemirror/view'
import { clone } from 'lodash-es'
import { Codemirror } from 'vue-codemirror'

// import Codemirror from 'vue-codemirror6' //接口变化

export default {
	components: { Codemirror, ParameterForm, ColumnForm, TagEditor },
	emits: ['update:object'],

	props: {
		value: { type: Object },
		errors: {
			type: Object,
			default: () => ({})
		}
	},
	data: () => ({
		form: {},
		refs: {},
		options: {},
		extensions: [
			sql(),
			oneDark,
			EditorView.theme({
				'.cm-content': {
					fontSize: '14px',
					fontFamily: 'Monaco, Menlo, "Ubuntu Mono", monospace'
				}
			})
		],
		editingParameter: {},
		editingColumn: {},
		showParameterForm: false,
		showColumnForm: false,
		parameterErrors: {},
		columnErrors: {},
		parameters: [],
		columns: []
	}),
	computed: {
		codemirror() {
			return this.$refs.cmEditor?.view
		}
	},
	watch: {
		value: {
			handler(nv) {
				if (nv) {
					this.form = clone(nv)
				} else this.form = {}
			},
			immediate: true
		}
	},
	mounted() {
		this.$http.get(`/report/meta/ReportStatus,ReportType`).then((r) => {
			this.options = r
		})
		if (this.form.id) {
			this.getParameters(this.form.id)
			this.getColumns(this.form.id)
		} else {
			//可能是复制过来的
			this.columns = this.form.columns
			this.parameters = this.form.parameters
		}
	},
	methods: {
		onTagsChanged(tags) {
			this.form.tags = tags
		},
		clear() {
			this.form = {}
		},
		getParameters(id) {
			this.$api.report.getParameters(id, (r) => {
				this.parameters = r
			})
		},
		getColumns(id) {
			this.$api.report.getColumns(id, (r) => {
				this.columns = r
			})
		},
		addParameter() {
			if (!this.form.id) {
				alert('请先保存报表')
				return
			}
			this.editingParameter = {
				report_id: this.form.id,
				status: 'valid'
			}
			this.showParameterForm = true
		},
		updateParameter(p) {
			this.editingParameter = p
			this.showParameterForm = true
		},
		removeParameter(p) {
			this.$confirm('确定要删除参数？').then((r) => {
				if (r) {
					this.$api.report.removeParameter(p.id, (r) => {
						alert('删除成功')
						this.getParameters(this.form.id)
					})
				}
			})
		},
		saveParameter(form) {
			this.$api.report.updateParameter(
				form,
				(r) => {
					alert('保存成功')
					this.getParameters(this.form.id)
					this.showParameterForm = false
					this.editingParameter = null
				},
				(err) => {
					this.parameterErrors = err.data
				}
			)
		},
		addColumn() {
			if (!this.form.id) {
				alert('请先保存报表')
				return
			}
			this.editingColumn = {
				report_id: this.form.id,
				status: 'valid'
			}
			this.showColumnForm = true
		},
		updateColumn(p) {
			this.editingColumn = p
			this.showColumnForm = true
		},
		removeColumn(p) {
			this.$confirm('确定要删除列？').then((r) => {
				if (r)
					this.$api.report.removeColumn(p.id, (r) => {
						alert('删除成功')
						this.getColumns(this.form.id)
					})
			})
		},
		saveColumn(form) {
			this.$api.report.updateColumn(
				form,
				(r) => {
					alert('保存成功')
					this.getColumns(this.form.id)
					this.showColumnForm = false
					this.editingColumn = null
				},
				(err) => {
					this.columnErrors = err.data
				}
			)
		}
	}
}
</script>
<style>
.CodeMirror {
	height: 100%;
}
</style>
